namespace TabAurous.OMS {
    export interface AdditionalChargesRow {
        AdditionalChargeId?: number;
        AdditionalChargeCode?: string;
        AdditionalChargeName?: string;
        ApplicableOn?: Common.AdditionalChargesType;
        ProductCalculateOn?: Common.AdditionalChargesProductCalcon;
        TransactionCalculateOn?: Common.AdditionalChargesTransactionCalcon;
        IncludeTax?: boolean;
        ExcludeDiscount?: boolean;
        RateType?: Common.AdditionalChargesRateType;
        Rate?: number;
        Narration?: string;
        Vouchers?: number[];
    }

    export namespace AdditionalChargesRow {
        export const idProperty = 'AdditionalChargeId';
        export const nameProperty = 'AdditionalChargeCode';
        export const localTextPrefix = 'OMS.AdditionalCharges';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            AdditionalChargeId = "AdditionalChargeId",
            AdditionalChargeCode = "AdditionalChargeCode",
            AdditionalChargeName = "AdditionalChargeName",
            ApplicableOn = "ApplicableOn",
            ProductCalculateOn = "ProductCalculateOn",
            TransactionCalculateOn = "TransactionCalculateOn",
            IncludeTax = "IncludeTax",
            ExcludeDiscount = "ExcludeDiscount",
            RateType = "RateType",
            Rate = "Rate",
            Narration = "Narration",
            Vouchers = "Vouchers"
        }
    }
}
